module.exports = __webpack_public_path__ + "static/nexxen-white-530abc89eb10533e5cad5f52d56cbc6d.svg";